import { get } from "@/apis";
import router from "@/router";
import { parseErrorMessage } from "@/utils/util";
import message from "ant-design-vue/lib/message";

export default {
  namespaced: true,
  state: {
    IsRenderingCompleted: false, // 是否渲染完成
    // 头部和底部图片
    config: {
      activityId: 0,
      alias: 0,
      background: "",
      banner: "",
      conditionSettingStr: "",
      conditionSettings: [],
      footer: "",
      receiptName: "",
      status: "",
      tip: "",
      verifyMode: 0,
    },
  },
  mutations: {
    SET_CONFIG(state, payload) {
      state.config = payload;
    },
    SET_RENDERING_COMPLETED(state) {
      state.IsRenderingCompleted = true;
    },
  },
  getters: {
    getConfig: (state) => {
      return state.config;
    },
    getBanner: (state) => {
      return state.config.banner || false;
    },
    getFooter: (state) => {
      return state.config.footer || false;
    },
    getIsRenderingCompleted: (state) => {
      return state.IsRenderingCompleted;
    },
  },
  actions: {
    async setConfig(context, data) {
      // 远程加载配置
      message.open({
        content: "配置加载中...",
        type: "loading",
        duration: 1,
      });
      const { alias } = data;
      const res = await get(`/api/BizReceipt/GetReceiptConfigByAlias/${alias}`);

      if (res.code === 200 && res.success) {
        // 设置系统主色
        document.documentElement.style.setProperty(
          "--primary-color",
          res.data.primaryColor
        );
        // 设置系统反色
        document.documentElement.style.setProperty(
          "--primary-inverse-color",
          res.data.inverseColor
        );
        context.commit("SET_CONFIG", res.data);
      } else {
        var pem = parseErrorMessage(res.message);
        if (!!pem) {
          router.push(`/error?title=[${pem.code}]&msg=${pem.message}`);
        }
      }
    },
    setIsRenderingCompleted(context) {
      context.commit("SET_RENDERING_COMPLETED");
    },
  },
};
